export var restrictedTimingKeys = ['ssr'];
export var clsWaitTimeMs = 7500;